import React, { Component } from "react";
import TextField from "material-ui/TextField";
import Paper from "material-ui/Paper";
import RaisedButton from "material-ui/RaisedButton";
import uuid from "uuid/v1";
import FireBase from "firebase/app";
import firebase from "../firebase";
import FileUpload from "../components/FileUpload";
import BusinessHours from "../components/BusinessHours";
import { Toggle, CircularProgress } from "material-ui";
import LinearProgress from "../components/LinearProgress";
import { minutesToDate, dateToMinutes } from "../../functions/common/dateUtils";
import LinkWithStripe from "../components/LinkWithStripe";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  form: {},
  paper: {
    padding: 20,
  },
  gridList: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
  },
  saveButton: {
    marginTop: 15,
  },
};

class EditLocation extends Component {
  state = {
    address: "",
    name: "",
    city: "",
    state: "",
    zipcode: "",
    phone: "",
    email: "",
    imageUrl: "",
    hoursText: "",
    orderLink: "",
    hoursText: "",
    enableOnlineOrders: false,
    locationId: null,
    restaurantId: null,
    minOrderAmount: 0,
    uploadProgress: 0,
    uploading: false,
    createMode: false,
    active: false,
    loading: false,
    submitting: false,
    taxRate: 0.0,
    hours: {
      monday: {},
      tuesday: {},
      wednesday: {},
      thursday: {},
      friday: {},
      saturday: {},
      sunday: {},
    },
  };

  async componentDidMount() {
    const { params } = this.props;
    const restaurantId = params.restaurantId;
    const locationId = params.locationId;

    if (!restaurantId) {
      console.log("No ID");
      return;
    }

    this.locationPath = firebase
      .firestore()
      .collection("restaurant")
      .doc(restaurantId)
      .collection("establishment");

    if (!locationId) {
      this.setState({
        createMode: true,
        restaurantId,
      });
      return;
    }

    this.setState({
      loading: true,
    });

    try {
      const locationSnap = await this.locationPath.doc(locationId).get();
      const restaurantSnap = await firebase
        .firestore()
        .collection("restaurant")
        .doc(restaurantId)
        .get();
      const location = locationSnap.data();

      this.setState({
        ...location,
        locationId,
        restaurantId,
        stripe_account: restaurantSnap.data().stripe_account,
        loading: false,
      });
    } catch (e) {
      console.log({ e });
    }
  }

  handleImageDrop = (accepted, reject) => {
    const { restaurantId } = this.state;
    const file = accepted[0];
    const metadata = {
      contentType: file.type,
    };

    const uploadTask = firebase
      .storage()
      .ref(`/restaurants/${restaurantId}/establishments/${uuid()}${file.name}`)
      .put(file, metadata);

    uploadTask.on(
      FireBase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.setState({
          uploadProgress: progress,
          uploading: true,
        });
      },
      (error) => {},
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          this.setState({
            imageUrl: downloadURL,
            uploading: false,
          });
        });
      }
    );
  };

  handleSubmit = async () => {
    this.setState({
      submitting: true,
    });

    const {
      name,
      address,
      city,
      state,
      zipcode,
      phone,
      imageUrl,
      hours,
      createMode,
      locationId,
      email,
      active,
      minOrderAmount,
      taxRate,
      orderLink,
      hoursText,
      enableOnlineOrders,
    } = this.state;

    const data = {
      name,
      address,
      city,
      state,
      zipcode,
      phone,
      imageUrl,
      hours,
      email,
      active,
      minOrderAmount,
      taxRate,
      orderLink,
      hoursText,
      enableOnlineOrders,
    };

    if (createMode) {
      await this.locationPath.add(data);
    } else {
      await this.locationPath.doc(locationId).update(data);
    }

    this.props.router.goBack();
  };

  renderBusinessHours = () => {
    const days = [
      { label: "Monday", key: "monday" },
      { label: "Tuesday", key: "tuesday" },
      { label: "Wednesday", key: "wednesday" },
      { label: "Thursday", key: "thursday" },
      { label: "Friday", key: "friday" },
      { label: "Saturday", key: "saturday" },
      { label: "Sunday", key: "sunday" },
    ];

    return days.map(({ label, key }) => (
      <BusinessHours
        day={label}
        active={this.state.hours[key].active}
        onToggle={(e, active) =>
          this.setState({
            hours: {
              ...this.state.hours,
              [key]: { ...this.state.hours[key], active },
            },
          })
        }
        openingTime={minutesToDate(this.state.hours[key].open)}
        closingTime={minutesToDate(this.state.hours[key].close)}
        onChangeOpening={(e, openingTime) =>
          this.setState({
            hours: {
              ...this.state.hours,
              [key]: {
                ...this.state.hours[key],
                open: dateToMinutes(openingTime),
              },
            },
          })
        }
        onChangeClosing={(e, closingTime) =>
          this.setState({
            hours: {
              ...this.state.hours,
              [key]: {
                ...this.state.hours[key],
                close: dateToMinutes(closingTime),
              },
            },
          })
        }
      />
    ));
  };

  render() {
    const {
      enableOnlineOrders,
      hoursText,
      createMode,
      name,
      address,
      city,
      state,
      zipcode,
      phone,
      email,
      imageUrl,
      minOrderAmount,
      active,
      loading,
      uploading,
      submitting,
      taxRate,
      orderLink,
    } = this.state;

    if (loading) return <LinearProgress />;

    return (
      <div style={styles.root}>
        <h2>{createMode ? "Add Location" : "Edit Location"}</h2>
        <form style={styles.form}>
          <Paper style={styles.paper}>
            <TextField
              hintText="To easily identify this location"
              value={name}
              onChange={(e) => this.setState({ name: e.target.value })}
              fullWidth
              floatingLabelText="Location Name"
            />
            <TextField
              hintText="Street address"
              value={address}
              onChange={(e) => this.setState({ address: e.target.value })}
              fullWidth
              floatingLabelText="Address"
            />
            <TextField
              hintText="City"
              value={city}
              onChange={(e) => this.setState({ city: e.target.value })}
              fullWidth
              floatingLabelText="City"
            />
            <TextField
              hintText="State"
              value={state}
              onChange={(e) => this.setState({ state: e.target.value })}
              fullWidth
              floatingLabelText="State"
            />
            <TextField
              hintText="ZIP Code"
              value={zipcode}
              onChange={(e) => this.setState({ zipcode: e.target.value })}
              fullWidth
              floatingLabelText="ZIP Code"
            />
            <TextField
              hintText="Phone Number"
              value={phone}
              onChange={(e) => this.setState({ phone: e.target.value })}
              fullWidth
              floatingLabelText="Phone Number"
            />

            {/* <TextField
                hintText="Online Order Link"
                value={orderLink}
                onChange={e => this.setState({ orderLink: e.target.value })}
                fullWidth
                floatingLabelText="Online Order Link"
              /> */}
            <Toggle
              label="Active"
              labelPosition="right"
              toggled={active}
              onToggle={(e, active) => this.setState({ active })}
              style={{ marginTop: 10, marginBottom: 10 }}
            />
          </Paper>
          <h2>Online Ordering</h2>
          <Paper style={{ padding: 15, display: "flex", flexWrap: "wrap" }}>
            {this.renderOnlineOrderingSection()}
          </Paper>
          <h2>Hours of Operation</h2>
          <Paper style={{ padding: 15 }}>
            {/* <TextField
                hintText="M - F 10 AM to 7 PM"
                value={hoursText}
                onChange={e => this.setState({ hoursText: e.target.value })}
                fullWidth
                floatingLabelText="Hours of Operation"
              /> */}
            {this.renderBusinessHours()}
          </Paper>
          <h2>Image</h2>
          <Paper style={{ padding: 15, display: "flex", flexWrap: "wrap" }}>
            <FileUpload
              style={{ marginRight: 15 }}
              multiple={false}
              onDrop={this.handleImageDrop}
              accept="image/png, image/jpeg"
              uploadProgress={this.state.uploadProgress}
              uploading={this.state.uploading}
            />
            <img src={imageUrl} style={{ maxHeight: 200 }} />
          </Paper>
          <RaisedButton
            label="Cancel"
            style={{ marginRight: 10, alignSelf: "flex-end" }}
            onTouchTap={() => this.props.router.goBack()}
          />
          <RaisedButton
            label="Save"
            style={styles.saveButton}
            onTouchTap={this.handleSubmit}
            secondary
            disabled={uploading || submitting}
          />
        </form>
      </div>
    );
  }

  renderOnlineOrderingSection() {
    const {
      enableOnlineOrders,
      email,
      minOrderAmount,
      taxRate,
      stripe_account,
      restaurantId,
    } = this.state;
    
    if (!stripe_account) return <LinkWithStripe restaurantId={restaurantId} />;

    return (
      <div>
        <Toggle
          label="Accept online orders"
          labelPosition="right"
          toggled={enableOnlineOrders}
          onToggle={(e, enableOnlineOrders) =>
            this.setState({ enableOnlineOrders })
          }
          style={{ marginTop: 10, marginBottom: 10 }}
        />
        <TextField
          hintText="For online order alerts"
          value={email}
          onChange={(e) => this.setState({ email: e.target.value })}
          fullWidth
          type="email"
          floatingLabelText="Email"
        />
        <TextField
          hintText="Minimum order amount"
          value={minOrderAmount}
          onChange={(e) => this.setState({ minOrderAmount: e.target.value })}
          fullWidth
          floatingLabelText="Minimum order"
          type="number"
          step={1}
        />
        <TextField
          floatingLabelText="Taxes"
          hintText="Tax percetage for online orders"
          value={taxRate * 100}
          onChange={(e) => this.setState({ taxRate: e.target.value / 100 })}
          type="number"
          fullWidth
          step={0.1}
        />
      </div>
    );
  }
}

export default EditLocation;



// WEBPACK FOOTER //
// ./src/pages/EditLocation.js